import React from 'react';

const Loader = ({ fullscreen = false }) => (
	<div className={`loader-wrapper ${fullscreen ? 'fullscreen' : 'inline' }`}>
		<div className="lds-ripple"><div></div><div></div></div>
	</div>
)

export default Loader
